/**
 * Converte o resultado reportado pelo renderer em campos de proof-of-play (F-07).
 *
 * - `played: false` → null (nenhum play log: falha de fonte/checksum, `play()` rejeitado, timeout etc.)
 * - Renderer legado que chama `onEnd()` sem argumento → tratado como exibido, com o tempo medido
 *   pelo loop desde que o item entrou em tela.
 * - Duração medida, limitada à programada (a API calcula completionRate = reportado / programado)
 *   e arredondada a centésimos; `playedAt` = INÍCIO da exibição.
 */
import type { PlaybackResult } from '@/types/player.types'

export interface PlayMeasurement {
  durationSeconds: number
  playedAt: string
}

export function measurePlayback(
  scheduledSeconds: number,
  result: PlaybackResult | undefined,
  itemStartedAt: number,
  now: number = Date.now()
): PlayMeasurement | null {
  if (result && !result.played) return null

  const startedAt = result?.startedAt ?? itemStartedAt
  const measured = result?.actualSeconds ?? (now - startedAt) / 1000
  const capped = scheduledSeconds > 0 ? Math.min(measured, scheduledSeconds) : measured
  const durationSeconds = Math.round(capped * 100) / 100

  // A API exige durationSeconds > 0; nada mensurável em tela não é impressão.
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return null

  return { durationSeconds, playedAt: new Date(startedAt).toISOString() }
}
